import { ConfirmModal, ConfirmModal2, CustomNav, CustomNavLink, CustomSplitPane, SystemInformation, showErrToast, showToast } from "components/Common"
import ModalConfigPrinter from "components/Common/Modals/ModalConfigPrinter"
import ModalPreview from "components/Common/Modals/ModalPreview"
import { ExportExtension, ModuleIds, ReportAction, ReportResource } from "constant"
import { confirmValidPrint, confirmValidPrintVerSun, exportFileResult, getAuthorizePageByResourceName, getFileById, getFilePrintResult, pingToPrintService } from "helpers/app-backend"
import { GetDataUrlReportConfig, GetResourceReportConfig, GetResourceReportIdConfig, NameToSlug, getUrlParamByKey, getUserInfoStorage, insertUrlParam } from "helpers/utilities"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect, useDispatch } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Card, CardBody, Col, Row, TabContent, TabPane } from "reactstrap"
import { addNewFileResult } from "store/actions"
import {
    ApprovedValidAndPublishResult,
    SignTestResultResults,
    UnsignTestResultResults,
    clearTestResultDetail,
    clearUserValidate,
    getTestResultDetail, getTestResultResults, setLoadingChangeDetail
} from "store/laboratory/testResult/actions"
import SummaryInfo from "../TestResult/Detail/SummaryInfo"
import TabHistory from "../TestResult/Detail/TabHistory"
import TabResult from "../TestResult/Detail/TabResult"
import LeftFrame from "./LeftFrame"
import Header from "./LeftFrame/Header"
import TitleAndInfo from "./TitleAndInfo"
import { getGeneralSetting } from "store/setting/generalSetting/actions"
import { CheckIsExpiredViettel } from "helpers/app-backend/testResult_backend_helper"
import CheckExpireSADViettelModal from "../TestResult/Detail/TabResult/Modal/CheckExpireSADViettelModal"

const RESOURCE = ModuleIds.PatientGroup
let positionHeader = 70
const PatientGroup = ({
    history,
    testResult = {},
    t,
    onGetTestResultDetail,
    onAddNewFileResult,
    onRefresh,
    loadingDetail,
    match,
    onApprovedValidAndPublishResult,
    isFastValidate,
    onSignTestResultResults,
    onUnsignTestResultResults,
    userValidate,
    onClearUserValidate,
    generalSetting,
    onGetGeneralSetting
}) => {
    const [idResult, setIdResult] = useState(match.params.id)
    const [isClone, setIsClone] = useState(false)
    const [modal, setModal] = useState(false)
    const formTable = useRef(null)
    const [currentTab, setCurrentTab] = useState(getUrlParamByKey('tab') || '1')
    const [actionState, setActionState] = useState('')
    const [open, setOpen] = useState(false)
    const [modalPreview, setModalPreview] = useState(false)
    const [testResultChange, setTestResultChange] = useState([])
    const [isSpin, setIsSpin] = useState(false)
    const [confirmSendResultModal, setConfirmSendResultModal] = useState(false)
    const isIntegration = generalSetting && generalSetting?.find(item => item.fieldName === 'IntegratedApproval')?.fieldValue === 'Integration'
    const smartCA = generalSetting && generalSetting?.find(item => item.fieldName === 'SmartCA')?.fieldValue || ""
    const [patientDetail, setPatientDetail] = useState({})
    const [reportInfos, setReportInfos] = useState([])
    const [group, setGroup] = useState({})
    const [requestDate, setRequestDate] = useState('')
    const [rows, setRows] = useState([])
    const userInfo = JSON.parse(localStorage.getItem("userInfo"))
    const [printerName, setPrinterName] = useState('')
    let printResultConfig = localStorage.getItem("printResultConfig")
    const isUseHis = generalSetting && generalSetting?.find(item => item.fieldName === 'UseHis')?.fieldValue === 'True'
    const [authorizeVTModal, setAuthorizeVTModal] = useState(false);
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        const tmpPrinter = printResultConfig ? JSON.parse(printResultConfig) : {}
        setPrinterName(tmpPrinter?.printerName)
    }, [printResultConfig])

    const dispatch = useDispatch()
    useEffect(() => {
        onGetGeneralSetting(userInfo?.company)
        setCurrentTab(`${getUrlParamByKey('tab')}`)
        return () => {
            //xóa result cũ
            dispatch(clearTestResultDetail())
        }
    }, [])

    useEffect(() => {
        if (getUrlParamByKey('tab') != currentTab) {
            insertUrlParam({ tab: currentTab })
        }
    }, [currentTab])
    useEffect(() => {
        setCurrentTab(getUrlParamByKey('tab'))
    }, [window.location.search])
    const [rowEdit, setRowEdit] = useState({})
    const [confirmModal, setConfirmModal] = useState(false);
    const toggleModal = () => {
        setModal(prev => !prev)
    }

    useEffect(() => {
        loadReportInfo()
        onClearUserValidate()
    }, [])


    const loadReportInfo = async () => {
        let res = await getAuthorizePageByResourceName("_" + ModuleIds.TestResult);
        if (res) {
            setReportInfos(res._ReportInfo)
        }
    }

    useEffect(() => {
        if (loadingDetail == true) {
            setIsSpin(true)
        }
        else {
            setIsSpin(false)
        }
    }, [loadingDetail])

    useEffect(() => {
        if (idResult) {
            setIsSpin(true)
            onGetTestResultDetail({
                id: idResult, callback: () => {
                }
            })
        }
    }, [idResult])

    useEffect(() => {
        setModal(false)
    }, [testResult.id])

    useEffect(() => {
        if (testResult.id)
            onRefresh(testResult.id)
    }, [testResult.fileId])


    const onEditHandler = () => {
        setIsClone(false)
        toggleModal()
    }

    const onCloneHandler = () => {
        setIsClone(true)
        toggleModal()
    }

    const toggleParamModal = () => {
        setModal(prev => !prev)
    }

    useEffect(() => {
        setRowEdit(testResult)
    }, [testResult])

    const onDelete = () => {
        setConfirmModal(true)
    }

    const onDeleteToggleHandler = (e, param) => {
        setConfirmModal(false)
    }

    const onDeleteRequestsHandler = () => {
        onDeleteRequests({ requests: [testResult], callback: callback() })
    }

    const callback = () => {
        const url = `/TestResult`
        setConfirmModal(false)
        history.replace(url)
    }
    const PrintConfig = async () => {
        if (reportInfos.length > 0 && !isEmpty(reportInfos[0].uri)) {
            let res
            if (!isFastValidate) {
                res = await getFilePrintResult({
                    ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                    ResultId: `${testResult.id}`,
                    testIds: formTable.current.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable.current.GetAllIdsHasResult(),
                    page: formTable.current.GetReportType()?.length > 0 ? formTable.current.GetReportType() : formTable.current.GetAllReportType(),
                    ValidatedBy: userValidate,
                    PrinterName: printerName
                })
            } else {
                const id = testResult.id
                const params = {
                    Module: ModuleIds.TestResult,
                    ItemAction: ReportAction.Create,
                    ItemValue: `${id}`,
                    reportParameters: {
                        ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                        ResultId: `${testResult.id}`,
                        SampleTypes: formTable.current.GetSampleType()?.length > 0 ? formTable.current.GetSampleType() : formTable.current.GetAllSampleType(),
                    },
                    orderCode: testResult.alternateId,
                    medicalId: testResult.medicalId,
                    patientName: NameToSlug(testResult.patientName)
                }
                res = await confirmValidPrintVerSun({
                    ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                    ResultId: `${testResult.id}`,
                    testIds: formTable.current.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable.current.GetAllIdsHasResult(),
                    page: formTable.current.GetReportType()?.length > 0 ? formTable.current.GetReportType() : formTable.current.GetAllReportType(),
                    ValidatedBy: userValidate,
                    PrinterName: printerName
                }, params)
                onGetTestResultDetail(testResult.requestId)
            }
            try {
                const getPingPrintService = await pingToPrintService();
                if (getPingPrintService.pingTime) {
                    const dataSendPrint = await sendDataPrint({
                        ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                        "filePath": `${res.reportUrl}`,
                        "printerNameBarcode": printerName
                        // "quantity": rowState.numberOfLabels
                    })
                    if (dataSendPrint === 'failed') {

                        showErrToast(
                            'Vui lòng chọn máy in'
                        )

                        setTimeout(() => {
                            window.open(process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl)
                        }, 1500)

                    }
                } else {
                    window.open(process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl)
                }
            }
            catch {
                window.open(process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl)
            }
        }
        else {
            const print = localStorage.getItem("printConfig")
            if (isEmpty(print)) {
                setOpen(true)
            }
            else {
                setModalPreview(true);
            }
        }
    }

    const onPrintHandler = (state) => {
        setActionState(state)
        PrintConfig()
        isFastValidate
    }
    const onPreviewHandler = (state) => {
        setActionState(state)
        setModalPreview(true);

    }
    const onExportHandler = async (state) => {
        setActionState(state)
        const id = testResult.id
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Export,
            ItemValue: `${id}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                "ResultId": `${id}`,
                "exportFormat": ExportExtension.pdf
            },
            orderCode: testResult.alternateId,
            medicalId: testResult.medicalId,
            patientName: NameToSlug(testResult.patientName)
        }
        const data = {
            ResultId: id,
            reportId: GetResourceReportIdConfig(reportInfos),
            testIds: formTable?.current?.GetIsPrintIds() || [],
        }
        const res = await exportFileResult(data, params)
        const fileData = await getFileById(res.id)
        let extension = ExportExtension.pdf;
        // let tempFileName = GetResourceReportNameConfig(reportInfos)
        let fileName = `${testResult.alternateId}_${params.patientName}_${testResult.medicalId}.${extension}`;

        const blob = new Blob([fileData], {
            type: 'application/octet-stream'
        })
        saveAs(blob, fileName)
    }

    const onReportSettingHandler = (state) => {
        setOpen(true);
    }

    const onCreateHandler = (state) => {
        setActionState(state)
        if (isIntegration) {
            setConfirmSendResultModal(true)
        } else {
            onCreateReport(testResult.id)
        }
    }
    const onCreateReport = async (id) => {
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Create,
            ItemValue: `${id}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                ResultId: `${testResult.id}`,
            },
            orderCode: testResult.alternateId,
            medicalId: testResult.medicalId,
            patientName: NameToSlug(testResult.patientName)
        }
        const data = {
            ResultId: id,
            reportId: GetResourceReportIdConfig(reportInfos),
            testIds: formTable.current.GetIsPrintIds() || [],
        }

        if (isIntegration) {
            onApprovedValidAndPublishResult({
                data: {
                    data, params
                }, callback: (id) => {
                    showToast(
                        `${t("message:SendingReportSucceeded")}`, true
                    )
                    onGetTestResultDetail(testResult.requestId)
                    setConfirmSendResultModal(prev => !prev)
                }
            })
        } else {
            onAddNewFileResult({
                data: {
                    data, params
                }, callback: () => {
                    onGetTestResultDetail(testResult.requestId)
                }
            })
        }
    }

    const massCreateReport = async () => {
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Create,
            ItemValue: `${0}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                ResultId: `${0}`,
            }
        }
        const data = {
            ResultId: 0,
            reportId: GetResourceReportIdConfig(reportInfos),
            testIds: [],
        }

        onAddNewFileResult({
            data: {
                data, params, rows: rows
            }, callback: () => {
                if (testResult?.requestId)
                    onGetTestResultDetail(testResult.requestId)
            }
        })
    }

    const rederGroupName = (per = 70) => {
        let groupName = document.getElementById("groupNamePatientGroup")
        let header = document.getElementById("patientGroupHeader")
        if (header && groupName) {
            positionHeader = 70
            let left = header.clientWidth * (100 - per) / 100 + 10
            groupName.style.left = `${left}px`
            if (window.innerWidth < 992) {
                groupName.style.position = 'unset'
            }
            else {
                groupName.style.position = 'absolute'
            }
        }
    }

    window.addEventListener('resize', () => {
        rederGroupName(positionHeader)
    });
    const toggleBarcodeSetting = () => {
        setOpen(prev => !prev)
    }
    const refHeader = useRef(null)
    // if (isEmpty(testResult)) return null;

    const onRequestDateChange = (value) => {
        setRequestDate(value)
    }

    const onSign = async (state) => {
        //kiểm tra hết hạn viettel
        if (smartCA == 'Viettel') {
            let userId = getUserInfoStorage("sub")
            let checkExpired = await CheckIsExpiredViettel({ UserId: userId })
            setIsExpired(checkExpired.isExpired)
            if (checkExpired && (checkExpired.isExpired == true || checkExpired.isExpired == null)) {
                setAuthorizeVTModal(true)
                return;
            }
        }
        setActionState(state)
        const id = testResult.id
        let page = formTable.current.GetReportType()?.length > 0 ? formTable.current.GetReportType() : formTable.current.GetAllReportType();
        let pageFormat = page.join(",")
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Export,
            ItemValue: `${id}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                "ResultId": `${id}`,
                "exportFormat": ExportExtension.pdf,
                Page: pageFormat,
                SampleTypes: formTable.current.GetAllSampleTypeHasResult() || [],
            },
            orderCode: testResult.alternateId,
            medicalId: testResult.medicalId,
            patientName: NameToSlug(testResult.patientName)
        }
        const data = {
            id: id,
            reportId: GetResourceReportIdConfig(reportInfos),
            testResultIds: formTable.current.GetIsValidIds() || [],
            request: params || {}
        }
        onSignTestResultResults(data, () => {
            formTable?.current?.AfterUpdate()
        })

    }

    const onUnsign = async (state) => {
        setActionState(state)
        const id = testResult.id
        let page = formTable.current.GetReportType()?.length > 0 ? formTable.current.GetReportType() : formTable.current.GetAllReportType();
        let pageFormat = page.join(",")
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Export,
            ItemValue: `${id}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                "ResultId": `${id}`,
                "exportFormat": ExportExtension.pdf,
                Page: pageFormat,
            },
            orderCode: testResult.alternateId,
            medicalId: testResult.medicalId,
            patientName: NameToSlug(testResult.patientName)
        }
        const data = {
            id: id,
            reportId: GetResourceReportIdConfig(reportInfos),
            testResultIds: formTable.current.GetIsValidIds() || [],
            request: params || {}
        }
        onUnsignTestResultResults(data, () => {
            formTable?.current?.AfterUpdate()
        })

    }

    return (
        <React.Fragment>
            <ModalConfigPrinter open={open} onClose={(state) => {

                setOpen(false)
            }}
                stateAction={actionState}
                resource={GetResourceReportConfig(reportInfos)}
                onPreviewClick={(state) => { onPreviewHandler(state) }}
                onPrintClick={(state) => { onPrintHandler(state) }}
                onExportClick={(state) => { onExportHandler(state) }}
            />
            {modalPreview &&
                <ModalPreview
                    modal={modalPreview}
                    toggle={() => { setModalPreview(false) }}
                    fileId={testResult.fileId}
                    reportId={GetResourceReportIdConfig(reportInfos)}
                    resourceReport={ReportResource.TestResult}
                    dataUrl={
                        {
                            ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, testResult.fileId),
                            "ResultId": `${testResult.id}`,
                            testIds: formTable.current.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable.current.GetAllIds(),
                            page: formTable.current.GetReportType()?.length > 0 ? formTable.current.GetReportType() : formTable.current.GetAllReportType(),
                        }}
                />
            }
            <div id="result-header-detail" className="" ref={refHeader}>
                <Row>
                    <Col lg="12" className="px-0" id="patientGroupHeader">
                        {testResult &&
                            <div className='header-result-detail position-relative'>
                                <div className="d-flex text-primary align-items-center" id="groupNamePatientGroup"
                                    style={{ zIndex: 1, top: '20px' }}>
                                    <i className="fa fa-users "></i>
                                    <div className="text-dark" style={{ marginLeft: 5, marginRight: 5 }}>{t("Group")}:</div>
                                    <div color="text-primary" style={{ fontWeight: 'bold' }}>{group.name}</div>
                                </div>
                                <TitleAndInfo
                                    rows={rows.filter(x => x.id > 0)}
                                    generalSetting={generalSetting}
                                    onEdit={onEditHandler}
                                    onClone={onCloneHandler}
                                    data={testResult}
                                    title={t("Patient Group")}
                                    subtitle={<>
                                        {testResult.sid ?
                                            <Link to={`/TestRequest/${testResult.requestId}/view?tab=1`} target="_blank">{`${testResult.sid}`}</Link>
                                            :
                                            <span>{t("Patient Group")}</span>
                                        }
                                    </>
                                    }
                                    resource={RESOURCE}
                                    onDelete={onDelete}
                                    resourceReport={GetResourceReportConfig(reportInfos)}
                                    onCreateClick={(state) => { onCreateHandler(state) }}
                                    onPrintClick={(state) => { onPrintHandler(state) }}
                                    onReportSettingClick={(state) => { onReportSettingHandler(state) }}
                                    onPreviewClick={(state) => { onPreviewHandler(state) }}
                                    onExportClick={(state) => { onExportHandler(state) }}
                                    testResults={testResultChange || []}
                                />
                            </div >}
                    </Col >
                </Row >
            </div >
            <div className="row" style={{ height: "calc(100% - 60px)", paddingTop: 5 }}>
                <CustomSplitPane
                    onChange={(val) => {
                        rederGroupName(val)
                    }}
                    LeftFrame={() => (
                        <div className="h-100 header-fixed" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                            <LeftFrame
                                requestDate={requestDate}
                                patientDetail={patientDetail}
                                onRefresh={() => { }}
                                onChangeGroup={(val) => {
                                    setGroup(val || {})
                                }}
                                toggleBarcodeSetting={toggleBarcodeSetting}
                                onRowClick={value => {
                                    if (idResult != value.id) {
                                        setPatientDetail(value)
                                        setIdResult(value.requestId)
                                    }
                                }}
                                onChangeRow={vals => setRows(vals)}
                                onMassCreateReport={massCreateReport}
                            />
                            <div className="result-detail-bottom-column">&nbsp;</div>
                        </div>
                    )}
                    RightFrame={() => (
                        <>
                            <div style={{ height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                                {isUseHis == true &&
                                    <Header data={testResult} onDateChange={onRequestDateChange} />
                                }
                                <div className="header-result-detail sumamry-info-result-detail">
                                    <SummaryInfo
                                        data={testResult}
                                        isPatientGroup={true}
                                        createdByName={testResult.createdByName}
                                        updatedByName={testResult.updatedByName}
                                        generalSetting={generalSetting}
                                    />
                                </div>
                                <Row className="flex-1" style={{ overflow: 'hidden' }}>
                                    {isSpin &&
                                        <div className="h-100 w-100" style={{
                                            position: 'absolute', zIndex: 9,
                                            background: 'rgba(256,256,256,0.5)'
                                        }}>
                                            <div className="w-100 h-100">
                                                <div className="text-center" style={{ marginTop: '50px' }}>
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <Col lg="12" className="h-100">
                                        <Card className="h-100">
                                            <CardBody className="h-100 pb-0" style={{ padding: '10px' }}>
                                                <div className="h-100" style={{ position: 'relative' }}>
                                                    <div className="d-none">
                                                        <SystemInformation t={t} data={rowEdit} />
                                                    </div>
                                                    <Row className="h-100">
                                                        <CustomNav
                                                            onToggle={e => {
                                                                if (e == "1") {
                                                                    setTimeout(() => {
                                                                        setCurrentTab(e);
                                                                        formTable.current?.ReSetColumns()
                                                                    }, 400);
                                                                }
                                                                else {
                                                                    setCurrentTab(e);
                                                                }
                                                                // setCurrentTab(e);
                                                            }}
                                                            defaultTab={currentTab}
                                                            tabs
                                                            className="nav-tabs-custom"
                                                            //onToggle={onGetTestRequestSample}
                                                            tabContents={customActiveTab => (
                                                                <TabContent
                                                                    activeTab={customActiveTab}
                                                                    className="p-3 text-muted pb-0"
                                                                    style={{ height: "calc(100% - 41px)" }}
                                                                >
                                                                    <TabPane tabId="1" className="h-100">
                                                                        {testResult.id &&
                                                                            <TabResult className="testsTab"
                                                                                isEdit={!isClone}
                                                                                // onValidSubmit={onValidSubmitTestsTab}
                                                                                data={[]}
                                                                                id={testResult.id}
                                                                                requestId={testResult.requestId}
                                                                                onRefreshDetail={() => { }}
                                                                                onChange={(values) => {
                                                                                    setTestResultChange(values)
                                                                                }}
                                                                                RESOURCE={ModuleIds.PatientGroup}
                                                                                currentTab={currentTab}
                                                                                generalSetting={generalSetting}
                                                                                ref={formTable}
                                                                                onSign={(state) => { onSign(state) }}
                                                                                onUnsign={(state) => { onUnsign(state) }}
                                                                            />}
                                                                    </TabPane>
                                                                    <TabPane tabId="2" className="h-100">
                                                                        {(testResult.id && currentTab == '2') &&
                                                                            <div className=" h-100 tab-history-detail-result">
                                                                                <TabHistory className="testsTab"
                                                                                    id={testResult.id}
                                                                                    currentTab={currentTab}
                                                                                />
                                                                            </div>}
                                                                    </TabPane>
                                                                </TabContent>
                                                            )}
                                                        >
                                                            {ListTabName.map(row => <CustomNavLink key={row.id} tabId={row.id.toString()}>
                                                                <span className="">{t(`${row.name}`)}</span>
                                                            </CustomNavLink>)
                                                            }
                                                        </CustomNav>
                                                    </Row>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <div className="result-detail-bottom-column">&nbsp;</div>
                            </div>
                        </>
                    )}
                    InitialSize={70}
                />
            </div>
            <ConfirmModal
                modal={confirmModal}
                title={`${t("common:Delete")} ${t("Test Result")}`}
                message={`${t("message:DeleteRecordConfirm", {
                    entity: `${t("testResultPage:Test Result")}`,
                })}`}
                onToggle={onDeleteToggleHandler}
                onDelete={onDeleteRequestsHandler}
            />
            <ConfirmModal2
                modal={confirmSendResultModal}
                title={`${t("testResultPage:Result")}`}
                message={`${t("testResultPage:Approved Valid Publish")}`}
                onToggle={() => setConfirmSendResultModal(prev => !prev)}
                onConfirm={() => { onCreateReport(testResult.id) }}
                btnConfirmText={t("testResultPage:Ok")}
                isEdit={true}
            />
            <CheckExpireSADViettelModal
                modal={authorizeVTModal}
                toggle={() => setAuthorizeVTModal(prev => !prev)}
                isExpired={isExpired}
            />
        </React.Fragment >
    )
}

const ListTabName = [
    {
        id: 1,
        name: 'common:Detail'
    },
    {
        id: 2,
        name: 'History'
    },
]

PatientGroup.propTypes = {
    testResult: PropTypes.object,
    onGetTestResultDetail: PropTypes.func,
    t: PropTypes.any,
}

const mapStateToProps = ({ testResult, generalSetting }) => {
    return ({
        testResult: testResult.testResult,
        loadingDetail: testResult.loadingDetail || false,
        isFastValidate: testResult.isFastValidate,
        userValidate: testResult.userValidate,
        generalSetting: generalSetting.generalSetting
    })
}

const mapDispatchToProps = dispatch => ({
    onGetTestResultDetail: id => dispatch(getTestResultDetail(id)),
    onRefresh: (id, callback) => dispatch(getTestResultResults({ id, callback })),
    onAddNewFileResult: (data, callback) => dispatch(addNewFileResult(data, callback)),
    onSetLoadingChangeDetail: (data) => dispatch(setLoadingChangeDetail(data)),
    onApprovedValidAndPublishResult: (data, callback) => dispatch(ApprovedValidAndPublishResult(data, callback)),
    onSignTestResultResults: (data, callback) => dispatch(SignTestResultResults(data, callback)),
    onUnsignTestResultResults: (data, callback) => dispatch(UnsignTestResultResults(data, callback)),
    onClearUserValidate: (data) => dispatch(clearUserValidate(data)),
    onGetGeneralSetting: payload => dispatch(getGeneralSetting(payload)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withTranslation(["patientGroup", "common", "testResultPage", "message"])(PatientGroup)))